export class BacsConditionForm {
  groupes: BacsConditionFormGroups[];
}

export class BacsConditionFormGroups {
  groupGuid: string;
  conditions: BacsConditionFormGroupsConditions[];
}

export class BacsConditionFormGroupsConditions {
  id: number;
  element: string;
  field: string;
  operator: string;
  value: string;
}
